import $ from 'jquery';
import state from './state';
import { getPPP, getSlidesContainer } from './utils';

import { ANIMATION_DURATION, MARGIN_SIZE, MIN_SLIDES } from './vars';

export function scrollSet(element, quantity) {
	$(element).queue(function () {
		$(this).scrollLeft(quantity);
		$(this).dequeue();
	});
}

export function scrollAnimate(
	direction,
	element,
	quantity,
	onFinish,
	duration = ANIMATION_DURATION
) {
	const directions = {
		left: `-=${quantity}`,
		right: `+=${quantity}`,
		set: quantity,
	};
	const scrollDirection = directions[direction];

	$(element).queue(function () {
		$(this).animate({ scrollLeft: scrollDirection }, duration, onFinish);
		$(this).dequeue();
	});
}

export function addInitialScroll(slider) {
	const sliderId = $(slider).attr('id');

	const fPs = state.get(sliderId, 'foundPosts');
	const ppp = getPPP(sliderId);
	if (fPs > ppp) {
		const slidesContainer = getSlidesContainer(slider);

		scrollAnimate(
			'set',
			slidesContainer,
			getScrollVars(slider).initialScroll
		);
	}
}

export function getScrollVars(slider) {
	let slidesWidth = 0,
		controlsWidth = 0,
		scrollSize = 0,
		preloadNum = 0,
		initialScroll = 0;

	const slidesContainer = getSlidesContainer(slider);
	const sliderId = $(slider).attr('id');

	const perPage = getPPP(sliderId);
	let rawWidth;
	const containerWidth = slidesContainer && slidesContainer.length && slidesContainer.get(0).clientWidth;
	if (slidesContainer.length) {
	}
	if (window.innerWidth > 480) {
		rawWidth = containerWidth / perPage;
	} else {
		rawWidth = containerWidth / MIN_SLIDES;
	}
	slidesWidth = Math.trunc(rawWidth) - MARGIN_SIZE;

	controlsWidth = slidesWidth / 2;

	scrollSize = slidesWidth + MARGIN_SIZE;

	preloadNum = state.get(sliderId, 'queriedPrev') || 0;

	initialScroll = preloadNum * scrollSize - Math.trunc(scrollSize / 2);

	return {
		controlsWidth,
		slidesWidth,
		scrollSize,
		initialScroll,
	};
}
